import React from 'react';

const HRCopilotHero = () => {
  return (
    <div>
      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .hero-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 60px 40px;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
          margin-top: -220px;
        }

        .hero-content {
          display: flex;
          align-items: center;
          gap: 60px;
          margin-bottom: 80px;
        }

        .hero-left {
          flex: 1;
        }

        .hero-text {
          margin-bottom: 24px;
        }

        .hero-subtitle {
          font-size: 20px;
          font-weight: 400;
          font-style: italic;
          color: #333;
          margin-bottom: 8px;
        }

        .hero-title {
          font-size: 52px;
          font-weight: 700;
          font-style: italic;
          color: #1a1a1a;
          display: flex;
          align-items: center;
          gap: 12px;
          line-height: 1.1;
        }

        .star-icon {
          font-size: 60px;
        }

        .hero-description {
          font-size: 18px;
          line-height: 1.7;
          color: #4a4a4a;
          margin-bottom: 32px;
          text-align: justify;
        }

        .hero-description strong {
          font-weight: 600;
          color: #1a1a1a;
        }

        .hero-buttons {
          display: flex;
          gap: 16px;
        }

        .btn-primary, .btn-secondary {
          background-color: #6b4c7f;
          color: white;
          border: none;
          padding: 14px 32px;
          font-size: 1rem;
          font-weight: 600;
          border-radius: 6px;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        .btn-primary {
          background-color: #6b4c9a;
          color: white;
        }

        .btn-primary:hover {
          background-color: #5a3d82;
        }

        .btn-secondary {
          background-color: #f0f0f0;
          color: #333;
        }

        .btn-secondary:hover {
          background-color: #e0e0e0;
        }

        .hero-right {
          flex: 1;
        }

        .hero-image {
          width: 100%;
          border-radius: 30%;
          overflow: hidden;
          aspect-ratio: 1;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
          max-width: 500px;
        }

        .hero-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          max-width: 800px;
        }

        .testimonial-section {
          background-color: #f8f8f8;
          border-radius: 12px;
          padding: 48px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 60px;
        }

        .testimonial-content {
          flex: 1;
          position: relative;
        }

        .quote-icon {
          font-size: 80px;
          color: #ffa500;
          font-family: Georgia, serif;
          line-height: 1;
          margin-bottom: -10px;
        }

        .testimonial-text {
          font-size: 20px;
          line-height: 1.6;
          color: #1a1a1a;
          font-weight: 500;
        }

        .testimonial-author {
          display: flex;
          align-items: center;
          gap: 20px;
        }

        .author-avatar {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          overflow: hidden;
          flex-shrink: 0;
        }

        .author-avatar img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .author-info {
          text-align: left;
        }

        .author-name {
          font-size: 18px;
          font-weight: 600;
          color: #1a1a1a;
          margin-bottom: 4px;
        }

        .author-title {
          font-size: 15px;
          color: #666;
          margin-bottom: 8px;
        }

        .author-company {
          font-size: 20px;
          font-weight: 600;
          color: #4CAF50;
          letter-spacing: 0.5px;
        }

        @media (max-width: 1024px) {
          .hero-content {
            flex-direction: column;
            gap: 40px;
          }

          .hero-title {
            font-size: 56px;
          }

          .testimonial-section {
            flex-direction: column;
            gap: 40px;
          }
        }

        @media (max-width: 768px) {
          .hero-container {
            padding: 40px 20px;
          }

          .hero-title {
            font-size: 42px;
          }

          .star-icon {
            font-size: 40px;
          }

          .hero-subtitle {
            font-size: 20px;
          }

          .hero-description {
            font-size: 16px;
          }

          .hero-buttons {
            flex-direction: column;
          }

          .btn-primary, .btn-secondary {
            width: 100%;
          }

          .testimonial-section {
            padding: 32px 24px;
          }

          .testimonial-text {
            font-size: 18px;
          }
        }
      `}</style>
      
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-left">
            <div className="hero-text">
              <h2 className="hero-subtitle">All-in-one solution for successful</h2>
              <h1 className="hero-title">
                <span className="star-icon">⭐</span>
                HR Management
              </h1>
            </div>
            
            <p className="hero-description">
              <strong>HR Copilot is a dedicated solution for human resourcesss,</strong> supporting 
              all your needs from employee onboarding and performance tracking 
              to payroll management and compliance monitoring.
            </p>
            
            <div className="hero-buttons">
              <button className="btn-primary">Start now</button>
              <button className="btn-secondary">Meet an advisor ▼</button>
            </div>
          </div>
          
          <div className="hero-right">
            <div className="hero-image">
              <img 
                src="/images/cir1.png" 
                alt="HR Team Collaboration" 
              />
            </div>
          </div>
        </div>
        
        <div className="testimonial-section">
          <div className="testimonial-content">
            <div className="quote-icon">"</div>
            <p className="testimonial-text">
              HR Copilot streamlined our entire HR workflow, saving us countless hours 
              on administrative tasks and allowing us to focus on employee development 
              and company culture.
            </p>
          </div>
          
          <div className="testimonial-author">
            <div className="author-avatar">
              <img 
                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop" 
                alt="Sarah Mitchell" 
              />
            </div>
            <div className="author-info">
              <h4 className="author-name">Sarah Mitchell - Head of HR</h4>
              <p className="author-title">Human Resources Director</p>
              <div className="author-company">HRCopilot</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HRCopilotHero;